<template>
  <div class="sale_page w-full">
    <div v-if="activityData !== null">
      <div class="activity lg:pb-6 xl:pb-16" id="activity" v-if="activityData.begin_at && activityData.end_at">
        <Breadcrumb :productTitle="activityData" v-if="$route.name !== 'groupBuyingTag'" />
        <div class="banner mb-4 overflow-hidden" ref="banner" v-if="activityData.cover_url">
          <img v-lazy="activityData.cover_url" alt="livaABC" class="w-full h-auto object-contain max-w-full">
        </div>

        <div class="mb-4">
          <h4 class="text-NotoSansBold text-lg mb-1">{{ activityData.name }}</h4>
          <p class="text-NotoSansRegular mb-1">活動時間：
            <span class="textColorRed">{{ moment(activityData.begin_at).format('MM/DD HH:mm') }} ~ {{ moment(activityData.end_at).format('MM/DD HH:mm') }}</span>
          </p>
          <div class="text-NotoSansRegular" v-html="activityData.description"></div>
        </div>

        <!-- <FreeGift
          v-if="freeGift_data && $store.state.nodeEnv !== 'production'"
          :planGifts="freeGift_data.gift_options"
          :gift_num="freeGift_data.action_quantity"
          :title="freeGift_data.name"
          v-on:getSelectGift="getSelectGift" /> -->

        <div class="flex justify-between" v-if="!isPenAndGifts && activityData.items && activityData.items.length > 0">
          <div class="w-full saleProducts flex flex-wrap">
            <div class="w-1/2 sm:w-1/3 p-2 flex-shrink" :class="{ 'lg:w-1/5': $route.name === 'groupBuyingTag' }" v-for="(item, index) in penAndGiftsItems" :key="index">
              <div class="border h-full">

                <ProductModule :data="item" />

              </div>
            </div>
          </div>
        </div>

        <div v-if="isPenAndGifts && activityData.items && activityData.items.length > 0">

          <div class="select_gift">
            <div class="flex justify-between bg-blue-500 p-2">
              <p class="p-3 bg-white text-blue-600">第一區</p>
              <p class="p-3 text-white">點讀筆必勾選</p>
            </div>
            <div class="select_gift_detail p-4 border-2 border-blue-500">
              <div class="main mb-4 md:mb-6 mx-auto" v-if="purchasePenData">
                <div class="flex mb-2 mb-lg-3 flex-wrap">
                  <div class="w-full md:w-2/5 mb-4 md:mb-0">
                    <img :src="purchasePenData.cover" alt="">
                    <!-- <Gallery :coverList="previewList" v-if="previewList && previewList.length > 0" :is_digital="purchasePenData.is_digital" :category_id="purchasePenData.category_id" /> -->
                  </div>
                  <div class="w-full md:w-3/5 md:pl-4 lg:pl-8">
                    <DetailContent :purchasePenData="purchasePenData" :activityData="activityData" :all_events="all_events" :isISBN="false" :isPrice="false" />
                  </div>
                </div>
              </div>
              <div class="flex justify-end">
                <DetailBtns v-if="purchasePenData" :purchasePenData="purchasePenData" :activityData="activityData"
                  :isAddCartNow="true" :iShopNow="false" :isAddWish="false" />
              </div>
            </div>
          </div>
          <div class="select_books">
            <div class="flex justify-between bg-blue-500 p-2">
              <p class="p-3 bg-white text-blue-600">第二區</p>
              <p class="p-3 text-white">請勾選活動書籍</p>
            </div>
            <div class="w-full saleProducts flex flex-wrap border-2 border-blue-500">
              <div class="w-1/2 sm:w-1/3 p-2 flex-shrink" :class="{ 'lg:w-1/5': $route.name === 'groupBuyingTag' }" v-for="(item, index) in penAndGiftsItems" :key="index">
                <div class="border h-full">
                  <ProductModule :data="item" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="pt-12 pb-12">
        <p class="text-NotoSansRegular text-center">活動不存在</p>
      </div>
    </div>

      <div class="loading md:p-1" v-if="!activityData">
        <div class="hidden md:block">
          <vue-content-loading :width="300" :height="100">
            <rect cx="30" cy="30" width="265" r="30" height="80" x="15" />
          </vue-content-loading>

          <vue-content-loading :width="300" :height="135" v-for="(item, index) in 2" :key="index">
            <rect cx="30" cy="30" width="65" r="30" height="80" x="15" />
            <rect cx="30" cy="80" r="50" x="10" y="85" rx="3" ry="3" width="75" height="4" />
            <rect x="10" y="95" rx="3" ry="3" width="55" height="4" />
            <rect x="10" y="105" rx="3" ry="3" width="20" height="4" />

            <rect cx="30" cy="30" width="65" r="30" height="80" x="115" />
            <rect cx="30" cy="30" r="50" x="110" y="85" rx="3" ry="3" width="75" height="4" />
            <rect x="110" y="95" rx="3" ry="3" width="70" height="4" />
            <rect x="110" y="105" rx="3" ry="3" width="20" height="4" />

            <rect cx="30" cy="30" width="65" r="30" height="80" x="215" />
            <rect cx="30" cy="30" r="50" x="210" y="85" rx="3" ry="3" width="75" height="4" />
            <rect x="210" y="95" rx="3" ry="3" width="70" height="4" />
            <rect x="210" y="105" rx="3" ry="3" width="20" height="4" />
          </vue-content-loading>
        </div>
        <div class="md:hidden">
          <vue-content-loading :width="300" :height="100">
            <rect cx="30" cy="30" width="265" r="30" height="80" x="15" />
          </vue-content-loading>
          <vue-content-loading :width="300" :height="200" v-for="(item, index) in 2" :key="index">
            <rect cx="30" cy="30" width="110" r="30" height="135" x="20" />
            <rect cx="30" cy="80" r="50" x="20" y="145" rx="3" ry="3" width="110" height="5" />
            <rect cx="30" cy="80" r="50" x="20" y="155" rx="3" ry="3" width="110" height="5" />
            <rect cx="30" cy="80" r="50" x="55" y="165" rx="3" ry="3" width="50" height="5" />

            <rect cx="30" cy="30" width="110" r="30" height="135" x="160" />
            <rect cx="30" cy="80" r="50" x="160" y="145" rx="3" ry="3" width="110" height="5" />
            <rect cx="30" cy="80" r="50" x="160" y="155" rx="3" ry="3" width="110" height="5" />
            <rect cx="30" cy="80" r="50" x="190" y="165" rx="3" ry="3" width="50" height="5" />
          </vue-content-loading>
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import Cart from '@/components/modules/addCart'
import ProductModule from '@/components/product/ProductModule'
import DetailContent from '@/components/product/DetailContent'
import DetailBtns from '@/components/product/DetailBtns'
import VueContentLoading from 'vue-content-loading'
import Breadcrumb from '@/components/product/Breadcrumb'
import ga4 from '@/components/modules/ga4'
// import FreeGift from '@/components/checkout/FreeGift'
export default {
  name: 'Sale',
  metaInfo () {
    return {
      title: this.page_title
    }
  },
  data () {
    return {
      page_title: '',

      activityData: null,

      purchasePenData: null,

      all_events: null,

      showAlertArr: ['81', '278']

      // freeGift_data: null
    }
  },
  mixins: [
    Cart,
    ga4
  ],
  computed: {
    isPenAndGifts () {
      let self = this
      // let penID = ['6559', '7483']
      if (self.activityData && self.activityData.rules && self.activityData.rules.length > 0 && self.activityData.rules[0].action_name && self.activityData.rules[0].action_name === 'fixed_price_and_specific') {
        return true
      } else {
        return false
      }
    },
    penAndGiftsItems () {
      let self = this
      // let penID = ['6559', '7483']
      if (self.isPenAndGifts) {
        let newArray = self.activityData.items.filter((el) => {
          // return penID.indexOf((el.id).toString()) < 0
          return el.id !== self.activityData.rules[0].action_value.id
        })

        return newArray
      } else {
        return this.activityData.items
      }
    }
  },
  components: {
    ProductModule,
    VueContentLoading,
    Breadcrumb,
    DetailContent,
    DetailBtns
    // FreeGift
  },
  watch: {
    '$route.query.tag': {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getEvent()
        }
      }
    }
  },
  created () {
    this.getEvent()
    this.getEvent_all()
    this.alert()
  },
  mounted () {
    // this.check()
  },
  methods: {
    getEvent_all () {
      let self = this
      axios.get('/promote_events?type=all')
        .then((response) => {
          self.all_events = response.data.data
        })
    },
    getPenData (id) {
      let self = this
      axios.get(`/product/${id}?scope=onSale`)
        .then((response) => {
          self.purchasePenData = response.data
        })
    },

    alert () {
      let self = this
      const imagePath = require('@/assets/images/alert/schoolAlert.jpg')

      if (self.showAlertArr.indexOf(self.$route.query.tag) > -1) {
        self.$swal.fire({
          imageUrl: imagePath,
          showConfirmButton: false,
          showCancelButton: false,
          showCloseButton: true,
          customClass: {
            header: 'p-0',
            container: '',
            popup: 'max-w-3xl w-full p-0',
            closeButton: 'p-12 text-transparent focus:outline focus:shadow-none shadow-none',
            image: 'm-0'
          }
        })
      }
    },

    getEvent () {
      let self = this
      self.activityData = null
      let listPath = `/promote_events/${self.$route.query.tag}`
      axios.get(listPath)
        .then((response) => {
          self.activityData = response.data
          self.page_title = response.data.name

          // ga4
          self.select_promotion(response.data)

          if (response.data.rules && response.data.rules.length > 0 && response.data.rules[0].action_name && response.data.rules[0].action_name === 'fixed_price_and_specific') {
            self.getPenData(response.data.rules[0].action_value.id)
          }
        })
        .catch((err) => {
          self.$swal({
            icon: 'error',
            title: err.response.data && err.response.data.msg ? err.response.data.msg : '',
            customClass: {
              container: 'text-sm text-base',
              popup: 'text-base',
              title: 'text-xl',
              confirmButton: 'bgLiveABCRed px-6 py-3'
            }
          })
            .then((result) => {
              if (result) {
                self.$router.push({ name: 'index' })
              }
            })
        })
    },
    routeChange (id, type) {
      let self = this
      if (type === 'PACKAGE' || type === 'ITEM') {
        // 套書
        self.$router.push({ name: 'detail', params: { category: 'package', id: id } })
      } else if (type === 'BOOK') {
        // 叢書
        self.$router.push({ name: 'detail', params: { category: 'book', id: id } })
      } else if (type === 'MAGAZINE' || type === 'PLAN') {
        // 雜誌
        self.$router.push({ name: 'detail', params: { category: 'magazine', id: id } })
      }
    }

    // check () {
    //   let self = this
    //   if (JSON.parse(localStorage.getItem('products'))) {
    //     let checkItem = JSON.parse(localStorage.getItem('products'))

    //     let checkData = {
    //       'items': checkItem,
    //       'isOutIsland': false,
    //       'sId': 'CreditCard',
    //       'coupon': null,
    //       'payment_type': 'CreditCard'
    //     }

    //     axios.post('/cart/check', checkData)
    //       .then((response) => {
    //         console.log(response)

    //         if (response.data.events && response.data.events.findIndex(item => item.type === 'specific') > -1) {
    //           self.freeGift_data = response.data.events[response.data.events.findIndex(item => item.type === 'specific')]
    //         }
    //       })
    //       .catch((err) => {
    //         console.log(err)
    //       })
    //   } else {
    //     self.products = null
    //   }
    // },

    // getSelectGift (getSelectGift) {
    //   let self = this
    //   // eslint-disable-next-line
    //   let event_gifts = {
    //     'id': self.freeGift_data.id,
    //     'selected_gifts': getSelectGift
    //   }
    //   localStorage.setItem('event_gifts', JSON.stringify(event_gifts))
    // }
  }
}
</script>

<style lang="scss">
.sale_page {
  .swal2-close {
    color: transparent !important;
  }
  ::-webkit-scrollbar {
    transition: box-shadow .2s;
      width: 4px;
  }
  .min-text {
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
  }
  .activity {
    width: 100%;
    margin: 0 auto;
    .saleProducts {
      width: calc(98% - 225px);
      @media (max-width: 1025px) {
        width: 98%;
      }
    }
  }
}

</style>
